/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout.index'
import { Route as LayoutHedgesRouteImport } from './routes/_layout.hedges'
import { Route as LayoutHedgesIndexRouteImport } from './routes/_layout.hedges.index'
import { Route as LayoutHedgesNewRouteImport } from './routes/_layout.hedges.new'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutHedgesRoute = LayoutHedgesRouteImport.update({
  id: '/hedges',
  path: '/hedges',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutHedgesIndexRoute = LayoutHedgesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutHedgesRoute,
} as any)
const LayoutHedgesNewRoute = LayoutHedgesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => LayoutHedgesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/login': typeof LoginRoute
  '/hedges': typeof LayoutHedgesRouteWithChildren
  '/hedges/new': typeof LayoutHedgesNewRoute
  '/hedges/': typeof LayoutHedgesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof LayoutIndexRoute
  '/hedges/new': typeof LayoutHedgesNewRoute
  '/hedges': typeof LayoutHedgesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/_layout/hedges': typeof LayoutHedgesRouteWithChildren
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/hedges/new': typeof LayoutHedgesNewRoute
  '/_layout/hedges/': typeof LayoutHedgesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/login' | '/hedges' | '/hedges/new' | '/hedges/'
  fileRoutesByTo: FileRoutesByTo
  to: '/login' | '/' | '/hedges/new' | '/hedges'
  id:
    | '__root__'
    | '/_layout'
    | '/login'
    | '/_layout/hedges'
    | '/_layout/'
    | '/_layout/hedges/new'
    | '/_layout/hedges/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/hedges': {
      id: '/_layout/hedges'
      path: '/hedges'
      fullPath: '/hedges'
      preLoaderRoute: typeof LayoutHedgesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/hedges/': {
      id: '/_layout/hedges/'
      path: '/'
      fullPath: '/hedges/'
      preLoaderRoute: typeof LayoutHedgesIndexRouteImport
      parentRoute: typeof LayoutHedgesRoute
    }
    '/_layout/hedges/new': {
      id: '/_layout/hedges/new'
      path: '/new'
      fullPath: '/hedges/new'
      preLoaderRoute: typeof LayoutHedgesNewRouteImport
      parentRoute: typeof LayoutHedgesRoute
    }
  }
}

interface LayoutHedgesRouteChildren {
  LayoutHedgesNewRoute: typeof LayoutHedgesNewRoute
  LayoutHedgesIndexRoute: typeof LayoutHedgesIndexRoute
}

const LayoutHedgesRouteChildren: LayoutHedgesRouteChildren = {
  LayoutHedgesNewRoute: LayoutHedgesNewRoute,
  LayoutHedgesIndexRoute: LayoutHedgesIndexRoute,
}

const LayoutHedgesRouteWithChildren = LayoutHedgesRoute._addFileChildren(
  LayoutHedgesRouteChildren,
)

interface LayoutRouteChildren {
  LayoutHedgesRoute: typeof LayoutHedgesRouteWithChildren
  LayoutIndexRoute: typeof LayoutIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutHedgesRoute: LayoutHedgesRouteWithChildren,
  LayoutIndexRoute: LayoutIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
